import React from "react";
import { PageProps } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { ServiceType } from "../../gatsby-node";

import Header from "../components/Header";
import Footer from "../components/Footer";

import SectionTitle from "../components/Typography/SectionTitle";
import ContactSection from "../components/sections/ContactSection";
import "../styles/services/services.css";

const Service = ({ pageContext }:PageProps<object,ServiceType>) => {
    
    const { title, slug, sections, contacts } = pageContext;

    console.log(sections);

    return (<>
        <Header />
        <main id="main-services" style={{marginTop:66}}>
            <section style={{paddingTop:48, paddingBottom:48}}>
                <div className="container">
                    <SectionTitle>{title}</SectionTitle>
                </div>
            </section>
            <section className="services-section">
                {sections && sections.map((section, index)=>(
                    <div className="container">
                        <article key={section.title + index} className="article-root">
                            <div className={`${index %2 === 0 ? "article-wrapper-reverse" : "article-wrapper"}`}>
                                <div className="article-image">
                                    <GatsbyImage 
                                    image={section.section.image.node.localFile.childImageSharp.gatsbyImageData}  
                                    imgClassName="article-image-img" 
                                    objectPosition="center"
                                    objectFit="cover"
                                    alt={"obrázek " + section.title}/>
                                </div>
                                <div className="article-text">
                                    <h2>{section.title}</h2>
                                    <p>{section.section.obsah}</p>    
                                </div>
                            </div>
                        </article>
                    </div>
                ))}
            </section>
            <ContactSection contacts={contacts.reverse() ?? []}/>
        </main>
        <Footer />
    </>)
}

export default Service;